import React, { useEffect, useRef, useState } from "react"
import { DropdownItem } from "reactstrap"
import toastr from "toastr"
import { get, post } from "helpers/api_helper"

export default function PlayerImpersonateAction({ account, dropdown = false }) {
  const [pending, setPending] = useState(false)
  const [feedback, setFeedback] = useState(null)
  const running = useRef(false)
  const mounted = useRef(true)
  useEffect(() => {
    mounted.current = true
    return () => { mounted.current = false }
  }, [])
  const impersonate = async () => {
    if (running.current) return
    running.current = true
    setFeedback(null)
    let popup
    let dashboard
    const showError = message => {
      if (mounted.current) setFeedback({ message })
      toastr.error(message)
    }
    try {
      const website = new URL(process.env.REACT_APP_WEB_URL)
      if (!["https:", "http:"].includes(website.protocol)) throw new Error("Invalid website")
      popup = window.open("", "_blank")
      if (!popup) {
        showError("Allow pop-ups for Control Panel, then try Impersonate again.")
        return
      }
      popup.opener = null
      setPending(true)
      const { data: issuer } = await get("/admin/accounts/auth", { timeout: 15000 })
      if (!issuer?.impersonateKey || !issuer.userId) throw new Error("Missing session")
      // Web now owns its host-only player cookie through the Next /api proxy.
      // Calling the API host directly creates a different browser session.
      // The key travels in the body: nginx, the Next proxy and the API gateway all log the URL.
      const auth = new URL("/api/accounts/auth?impersonate=true", website.origin)
      const response = await post(auth.toString(), { email: account.email, password: "password",
        impersonation: { userId: issuer.userId, key: issuer.impersonateKey } }, { timeout: 15000 })
      const player = response?.data
      if (!response?.success || !player?.isImpersonate || player.role !== "player"
        || String(player.id || player._id) !== String(account.id || account._id)) throw new Error("Session not confirmed")
      dashboard = new URL("/dashboard", website.origin).toString()
      if (popup.closed) throw new Error("Player tab closed")
      popup.location.replace(dashboard)
    } catch {
      try { popup?.close() } catch { /* A detached tab must not hide the result. */ }
      if (dashboard) {
        if (mounted.current) setFeedback({ message: "The player session is confirmed, but its tab could not be opened.", dashboard })
      } else showError("Player impersonation could not be confirmed. Please try again.")
    } finally {
      running.current = false
      if (mounted.current) setPending(false)
    }
  }
  const props = { onClick: impersonate, disabled: pending || !account?.email || account?.status !== "activated" }
  const label = pending ? "Opening session…" : "Impersonate"
  return <>{dropdown ? <DropdownItem {...props} toggle={false}>{label}</DropdownItem>
    : <button {...props} type="button" className="btn btn-secondary waves-effect waves-light btn-md">{label}</button>}
    {feedback && <div role="alert" className="alert alert-warning mt-2 mb-0">{feedback.message}
      {feedback.dashboard && <> <a href={feedback.dashboard} target="_blank" rel="noopener noreferrer">Open player dashboard</a></>}
    </div>}
  </>
}
